import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter, Routes, Route, Navigate,
} from 'react-router-dom';
import PrivateRoute from '../components/authGuard/PrivateRoute';
import PublicRoute from '../components/authGuard/PublicRoute';
import Loader from '../components/Loader';
import ProfilePdf from '../components/ProfilePdf';

import PageNotFound from '../pages/PageNotFound';

const RegistrationLayout = lazy(() => import('../pages/registration/RegistrationLayout'));
const AuthLayout = lazy(() => import('./layout/AuthLayout'));
const AdminLayout = lazy(() => import('./layout/AdminLayout'));
const WithdrawApplication = lazy(() => import('../pages/withdraw/WithdrawApplication'));
const MemberLayout = lazy(() => import('./layout/MembersLayout'));

const Router = () => (
  <BrowserRouter>
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path='/'>
          <Route index element={<Navigate to='/auth/login' />} />
          <Route
            path='registration/*'
            element={(
              <PrivateRoute>
                <RegistrationLayout />
              </PrivateRoute>
            )}
          />
          <Route
            path='auth/*'
            element={(
              <PublicRoute>
                <AuthLayout />
              </PublicRoute>
            )}
          />
          <Route
            path='application-withdrawn'
            element={(
              <PrivateRoute>
                <WithdrawApplication />
              </PrivateRoute>
            )}
          />
          <Route
            path='admin/*'
            element={(
              <PrivateRoute>
                <AdminLayout />
              </PrivateRoute>
            )}
          />
          <Route
            path='member/*'
            element={(
              <PrivateRoute>
                <MemberLayout />
              </PrivateRoute>
            )}
          />
          <Route
            path='profile/:id/pdf'
            element={(
              <PrivateRoute>
                <ProfilePdf />
              </PrivateRoute>
            )}
          />
        </Route>
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default Router;
